/**
 * MEGAKRUNCH Product Tabs
 * Custom element for horizontal tab switching with full accessibility.
 * Follows Dawn's web component pattern (see product-info.js, product-form.js).
 */
if (!customElements.get('mk-product-tabs')) {
  class MkProductTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.panels = [];
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick.bind(this));
        tab.addEventListener('keydown', this.handleKeydown.bind(this));
      });

      // Ensure first tab is active on load
      if (!this.tabs.some((t) => t.getAttribute('aria-selected') === 'true')) {
        this.activateTab(this.tabs[0]);
      }
    }

    handleClick(event) {
      this.activateTab(event.currentTarget);
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex;

      switch (event.key) {
        case 'ArrowRight':
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activateTab(this.tabs[newIndex]);
      this.tabs[newIndex].focus();
    }

    activateTab(selectedTab) {
      const targetId = selectedTab.getAttribute('aria-controls');

      // Deactivate all tabs
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      });

      // Deactivate all panels
      this.panels.forEach((panel) => {
        panel.setAttribute('aria-hidden', 'true');
      });

      // Activate selected tab
      selectedTab.setAttribute('aria-selected', 'true');
      selectedTab.setAttribute('tabindex', '0');

      // Activate corresponding panel
      const targetPanel = this.querySelector('#' + targetId);
      if (targetPanel) {
        targetPanel.setAttribute('aria-hidden', 'false');
      }
    }
  }

  customElements.define('mk-product-tabs', MkProductTabs);
}
